import { InstructionsTransferCtrl } from './instructions-transfer.controller';

export const InstructionsStepTransferComponent = {
  controller: InstructionsTransferCtrl,
  bindings: {
    nextStep: '&',
  },
  template: require('./instructions-transfer.html'),
};
